import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  DIARY_SLOT_SEARCH_REQUEST,
  DIARY_SLOT_CHECK_AVAILABILITY_REQUEST,
  DIARY_SLOT_BOOK_REQUEST,
  DIARY_SLOT_UPDATE_REQUEST,
} from "./actionType";
import {
  searchDiarySlotSuccess,
  searchDiarySlotFail,
  checkDiarySlotAvailabilitySuccess,
  checkDiarySlotAvailabilityFail,
  bookDiarySlotSuccess,
  bookDiarySlotFail,
  updateDiarySlotSuccess,
  updateDiarySlotFail,
} from "./action";
import {
  diarySlotSearchAPI,
  diarySlotCheckAvailabilityAPI,
  diarySlotBookAPI,
  diarySlotUpdateAPI,
} from "../../helpers/fakebackend_helper";

function* searchDiarySlotSaga({ payload }) {
  try {
    const response = yield call(diarySlotSearchAPI, payload);
    yield put(searchDiarySlotSuccess(response));
  } catch (error) {
    yield put(searchDiarySlotFail(error));
  }
}

function* checkDiarySlotAvailabilitySaga({ payload }) {
  try {
    const response = yield call(diarySlotCheckAvailabilityAPI, payload);
    yield put(checkDiarySlotAvailabilitySuccess(response));
  } catch (error) {
    yield put(checkDiarySlotAvailabilityFail(error));
  }
}

function* bookDiarySlotSaga({ payload }) {
  try {
    const response = yield call(diarySlotBookAPI, payload);
    yield put(bookDiarySlotSuccess(response));
  } catch (error) {
    yield put(bookDiarySlotFail(error));
  }
}

// Task 24646 - takeEvery, not takeLatest: two quick drags are two independent
// moves, and dropping the first would leave the board showing a change that was
// never saved.
function* updateDiarySlotSaga({ payload, meta }) {
  try {
    const response = yield call(diarySlotUpdateAPI, payload);
    yield put(updateDiarySlotSuccess(response, meta));
  } catch (error) {
    yield put(updateDiarySlotFail(error, meta));
  }
}

export function* watchUpdateDiarySlotSaga() {
  yield takeEvery(DIARY_SLOT_UPDATE_REQUEST, updateDiarySlotSaga);
}

export function* watchSearchDiarySlotSaga() {
  yield takeLatest(DIARY_SLOT_SEARCH_REQUEST, searchDiarySlotSaga);
}

export function* watchCheckDiarySlotAvailabilitySaga() {
  yield takeLatest(DIARY_SLOT_CHECK_AVAILABILITY_REQUEST, checkDiarySlotAvailabilitySaga);
}

export function* watchBookDiarySlotSaga() {
  yield takeLatest(DIARY_SLOT_BOOK_REQUEST, bookDiarySlotSaga);
}

export default function* DiarySlotSaga() {
  yield all([
    watchSearchDiarySlotSaga(),
    watchCheckDiarySlotAvailabilitySaga(),
    watchBookDiarySlotSaga(),
    watchUpdateDiarySlotSaga(),
  ]);
}
